export const colorPrimary = "#273878";
export const colorSecondary = "#65CCCE";
export const colorSecondary_2 = "#4ea7a9";
export const colorBorder = "#273878";
export const colorAdditional = "#F0F0F7";
export const colorTextAdditional = "#00007A";

export const colorError = "#FF6D6D";

export const colorWhite = "#FFFFFF";
export const colorBlack = "#273878";

export const colorAuthBackground = "#FFFFFF";

export const colorInputBorder = "#777777";
export const colorInputBorderGrayish = "#dadada";

export const colorGrayText = "rgba(0,0,0,.5)";
